import {Injectable, SecurityContext} from '@angular/core';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class IziviaSafeUrlService {

    constructor(protected readonly sanitizer: DomSanitizer) {
    }

    /** Possibility to be override*/
    public toSafeURL(url: string): SafeUrl {
        return this.sanitizer.sanitize(SecurityContext.URL, url);
    }
}
